import { FormattedMessage } from '../../util/reactIntl';
import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './LandingPage.duck';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

// Most visitors land here right after a photographer approached them in
// person, so this stays a persistent strip rather than an interrupting
// popup - a modal on first load would be poor timing for that visitor.
const PhotographerBanner = () => (
  <a
    href="/p/photographer-home"
    style={{
      display: 'block',
      textAlign: 'center',
      padding: '10px 16px',
      background: '#FFC930',
      color: '#1F2937',
      fontWeight: 600,
      fontSize: 14,
      textDecoration: 'none',
    }}
  >
    <FormattedMessage id="LandingPage.photographerBanner" />
  </a>
);

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error } = props;

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage error={error} />}
      bannerBelowTopbar={<PhotographerBanner />}
    />
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
